import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IContact } from '../../../shared/models/contact';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'contact-info-popup',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './contact-info-popup.component.html',
  styleUrl: './contact-info-popup.component.css'
})
export class ContactInfoPopupComponent {

  @Input() contact: IContact | null = null;
  @Output() close = new EventEmitter<void>();

  closeContactInfo() {
    this.contact = null;
  }
}
